export enum DepartmentsName {
    CentralAdministration = 'หน่วยงานส่วนกลาง',
    ProvincialAdministration = 'หน่วยงานส่วนภูมิภาค'
  }

export enum DepartmentsDetail {
    CentralAdministrationDetail = 'รายการย่อยหน่วยงานส่วนกลาง',
    ProvincialAdministrationDetail = 'รายการย่อยหน่วยงานส่วนภูมิภาค'
}

export enum DepartmentsCodeEnum {
  Central = 1,
  Provincial = 2,
}
